<app-step-progress [steps]="steps"></app-step-progress>
<app-page-title [title]="'TEST SUMMARY'"></app-page-title>

<div class="panel">
    <div class="row">
        <div class="col-12 col-sm-10">
            <div class="row">
                <div class="col-12 col-sm-5">
                    <h5>Test:</h5>
                </div>
                <div class="col-12 col-sm-7">
                    <span [ngClass]="testTypeCssClass">{{testSessionInformation.testTypeDisplayName}} Test</span>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-5">
                    <h5>TEST PURPOSE:</h5>
                </div>
                <div class="col-12 col-sm-7">
                    {{testPurposeOption.name}}<br />
                </div>
            </div>
        </div>
    </div>
</div>

<div class="panel">
    <div class="row">
        <div class="col-12 col-lg-10 col-md-9">
            <div class="row">
                <div class="col-12 col-sm-5">
                    <h5>TEST DATE & TIME:</h5>
                </div>
                <div class="col-12 col-sm-7">
                    {{testDate | customDate: 'selectedTestFormatDateTime'}}
                    <br *ngIf="testSessionInformation.isWebDelivery" />
                    <span *ngIf="testSessionInformation.isWebDelivery">(Time Zone: {{localTimeZone}})</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b>You must arrive 45 MINUTES prior to your {{testSessionInformation.testTypeDisplayName}} Test. Check-in for your test closes 15 MINUTES before the scheduled start time. If you arrive after this time, you will be denied entrance to the {{testSessionInformation.testTypeDisplayName}} Test and will not be eligible for a refund or transfer.</b>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="custom-control custom-checkbox">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="confirmation-check"
                            name="confirmationCheck"
                            [(ngModel)]="isConfirmation"
                        >
                        <label
                            class="custom-control-label"
                            for="confirmation-check"
                            style="font-weight: 500; font-size: 18px;"
                        >I have read and understood the above statement.</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-5">
                    <h5>Test Location:</h5>
                </div>
                <div class="col-12 col-sm-7">
                    <strong>{{testSessionInformation.testCentreName}}</strong><br />
                    <ng-container *ngIf="!testSessionInformation.isWebDelivery">
                        <ng-container *ngIf="testSessionInformation.testCentreAddressLine2 && testSessionInformation.testCentreAddressLine2.length > 0">{{testSessionInformation.testCentreAddressLine2}} - </ng-container>{{testSessionInformation.testCentreAddressLine1}}<br />
                        {{testSessionInformation.testCentreCity}}, {{testSessionInformation.testCentreRegion}} <span *ngIf="testSessionInformation.testCentrePostalCode.length > 0">{{testSessionInformation.testCentrePostalCode}}</span><br />
                        {{testCentreCountry}}<br />
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-2 col-md-3">
            <button
                type="button"
                class="btn btn-primary"
                (click)="redirectTestSelection()"
            >Change</button>
        </div>
    </div>
</div>

<div class="panel">
    <div class="row">
        <div class="col-12 col-sm-10">
            <div class="row">
                <div class="col-12 col-sm-5">
                    <h5>SCORE RATING:</h5>
                </div>
                <div
                    *ngIf="brandId === BrandEnum.CELPIP"
                    class="col-12 col-sm-7"
                >
                    Standard rating - 3-4 business days
                </div>
                <div
                    *ngIf="brandId === BrandEnum.CAEL"
                    class="col-12 col-sm-7"
                >
                    Standard rating - 8 business days
                </div>
            </div>
        </div>
    </div>
</div>

<h5>PROOF OF IDENTITY</h5>

<p class="highlight">Please ensure the following information matches the ID document you are using on the test day.</p>

<div
    *ngIf="proofOfIdentityPageSaveInfo"
    class="panel"
>
    <div class="row">
        <div class="col-12 col-lg-10 col-md-9">
            <div class="row">
                <div class="col-12 col-sm-5">
                    <b>Country Of Citizenship</b>
                </div>
                <div class="col-12 col-sm-5">
                    <b>Date Of Birth</b>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-5">
                    {{countryOfCitizenship}}
                </div>
                <div class="col-12 col-sm-5">
                    {{proofOfIdentityPageSaveInfo.dateOfBirth | date:'mediumDate'}}
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-12 col-sm-5">
                    <b>First | Given Name</b>
                </div>
                <div class="col-12 col-sm-5">
                    <b>Identity Document Type</b>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-5">
                    {{proofOfIdentityPageSaveInfo.firstName}}
                </div>
                <div class="col-12 col-sm-5">
                    {{identityDocumentType}}
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-12 col-sm-5">
                    <b>Middle Name</b>
                </div>
                <div class="col-12 col-sm-5">
                    <b>Document Number</b>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-5">
                    {{proofOfIdentityPageSaveInfo.middleName}}
                </div>
                <div class="col-12 col-sm-5">
                    {{proofOfIdentityPageSaveInfo.documentNumber}}
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-12 col-sm-5">
                    <b>Last Name</b>
                </div>
                <div class="col-12 col-sm-5">
                    <b>Expiry Date</b>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-5">
                    {{proofOfIdentityPageSaveInfo.lastName}}
                </div>
                <div class="col-12 col-sm-5">
                    {{proofOfIdentityPageSaveInfo.documentExpiryDate | date:'mediumDate'}}
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-12 col-sm-5">
                    <b>Gender</b>
                </div>
                <div class="col-12 col-sm-5">
                    <b>First Language</b>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-5">
                    {{gender}}
                </div>
                <div class="col-12 col-sm-5">
                    {{firstLanguage}}
                </div>
            </div>
            <br>

        </div>
        <div class="col-12 col-lg-2 col-md-3">
            <button
                type="button"
                class="btn btn-primary"
                (click)="redirectProofOfIdentity()"
            >Change</button>
        </div>
    </div>
</div>

<div class="panel">
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <p>By submitting an order to register for a test session you certify and confirm as follows:</p>
            </div>
            <div class="form-group">
                <span>1) You are the individual whose name and personal information are in the test session registration form,
                    and you personally provided all of the information. All of the information included in the registration form is true and complete.
                </span>
            </div>
            <div class="form-group">
                <span>2) You have read, understood, and agreed to the Paragon Testing Enterprises
                    <a
                        target="_blank"
                        href={{personalLookupInfo?.serviceTermForTestMaterials.url}}
                    >Service Terms for Test Sessions and Instructional Materials</a>
                    and the Paragon Testing Enterprises <a
                        target="_blank"
                        href={{personalLookupInfo?.generalTermOfService.url}}
                    >General Terms of Service</a>.
                </span>
            </div>
            <div class="form-group">
                <span>
                    3) You have read and understood the Paragon Testing Enterprises <a
                        target="_blank"
                        href={{personalLookupInfo?.privacyPolicy.url}}
                    >Privacy Policy</a>,
                    and you consent to the collection, use, disclosure, retention, and deletion of your personal information in accordance with the
                    Paragon Testing Enterprises Privacy Policy and as otherwise permitted by applicable law and you agree to have your personal information transferred to and stored in Canada.
                </span>
            </div>
        </div>
    </div>
</div>

<div class="control-button-row">
    <button
        type="button"
        class="btn btn-primary"
        (click)="addToCart()"
    >Agree & Proceed</button>
</div>
